exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2[data-v-796bf1a6]{text-align:center}.order_container[data-v-796bf1a6]{display:flex;flex-wrap:wrap;border:1px solid grey;margin:5px}.items[data-v-796bf1a6]{padding:10px}#view[data-v-796bf1a6]{font-size:18px;padding:5px;background-color:#ffcede;outline:none;border-radius:7px}#view[data-v-796bf1a6]:hover{background-color:#f098c0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-796bf1a6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Orders.vue
// module id = 640
// module chunks = 0